import React from 'react'
import { observer } from 'mobx-react-lite'
import { createGlobalStyle, css } from 'styled-components'
import { CMS } from '@odiupsk/up-api-client'
import { Icon, Grid, GridCol, Card, CardContent, ButtonLink, Overlay } from '../../ui-kit'

const Global = createGlobalStyle`
  .overlay--fill {
    position: relative;
    display: flex;
    align-items: initial;
    justify-content: initial;
    flex: 0 0 100%;
  }

  .card-content--fill {
    flex: 1 0 100%;
  }
`

const BannerWhiteBg = (props: CMS.Banner) => {
  return (
    <Card>
      <CardContent fill>
        <Grid>
          <GridCol size="fixed">
            <img src={props.images.icon!['1x']} alt="" className="mb img--fluid" />
          </GridCol>
          <GridCol size="auto">
            <h3 className="h4 mb-xxlarge">{props.title}</h3>
            <p dangerouslySetInnerHTML={{ __html: props.perex! }} />
            <ButtonLink
              target={props.link_new_window ? '_blank' : ''}
              href={props.link_url}
              size="tiny"
              space="condensed"
              className="mb-none"
              style={{ paddingLeft: 0 }}>
              {props.link_text}
              <Icon name="chevron-right" size="medium" className="icon--right" />
            </ButtonLink>
          </GridCol>
        </Grid>
      </CardContent>
    </Card>
  )
}

const BannerTurqouiseOverlay = (props: CMS.Banner) => (
  <Card className="no-border">
    <Overlay
      fill
      bgSrc={props.images.background!['1x']}
      color="transparent"
      contentClass="no-pad"
      css={css`
        .overlay__image-wrapper {
          border-radius: 3px;
        }
        .card__content {
          display: flex;
          height: 100%;
          flex: auto;
        }
      `}>
      <Grid>
        <GridCol size={{ m: 7 }}>
          <CardContent
            color="turquoise-opaque"
            size="space"
            style={{ borderTopLeftRadius: 3, borderBottomLeftRadius: 3 }}>
            <Grid>
              <GridCol size="auto">
                <h3 className="h5 text-color-white">{props.title}</h3>
                <p
                  className="text-color-white"
                  dangerouslySetInnerHTML={{ __html: props.perex! }}
                />
                <ButtonLink
                  style={{ paddingLeft: 0 }}
                  className="text-color-white mb-none"
                  target={props.link_new_window ? '_blank' : ''}
                  href={props.link_url}
                  size="tiny"
                  space="condensed">
                  {props.link_text}
                  <Icon name="chevron-right" size="medium" className="icon--right" />
                </ButtonLink>
              </GridCol>
            </Grid>
          </CardContent>
        </GridCol>
      </Grid>
    </Overlay>
  </Card>
)

const BannerTurqouiseBackground = (props: CMS.Banner) => (
  <Card className="no-border" color="turquoise-opaque">
    <Grid>
      <GridCol size={{ m: 7 }}>
        <div>
          <CardContent size="space">
            <Grid>
              <GridCol size="auto">
                <h3 className="h5 text-color-white">{props.title}</h3>
                <p
                  className="text-color-white"
                  dangerouslySetInnerHTML={{ __html: props.perex! }}
                />
                <ButtonLink
                  style={{ paddingLeft: 0 }}
                  className="text-color-white mb-none"
                  href={props.link_url}
                  target={props.link_new_window ? '_blank' : ''}
                  size="tiny"
                  space="condensed">
                  {props.link_text}
                  <Icon name="chevron-right" size="medium" className="icon--right" />
                </ButtonLink>
              </GridCol>
            </Grid>
          </CardContent>
        </div>
      </GridCol>
      <GridCol size="auto" style={{ display: 'flex' }}>
        <img style={{ alignSelf: 'center' }} src={props.images.image!['1x']} alt="" />
      </GridCol>
    </Grid>
  </Card>
)

export const Banners: React.FC<{
  banners: CMS.Banner[]
}> = observer(({ banners }) => {
  return (
    <Grid className="mb">
      <Global />
      {banners.map((data, id) => {
        return (
          <>
            {data.layout === 'dashboard-white-with-ico' && (
              <GridCol equalizeHeight key={id.toString()} className="mb" size={{ l: 6 }}>
                <BannerWhiteBg {...data} />
              </GridCol>
            )}
            {data.layout === 'dashboard-with-turquoise-overlay' && (
              <GridCol equalizeHeight key={id.toString()} className="mb" size={{ l: 6 }}>
                <BannerTurqouiseOverlay {...data} />
              </GridCol>
            )}
            {data.layout === 'dashboard-with-turquoise-background' && (
              <GridCol equalizeHeight key={id.toString()} className="mb" size={{ l: 6 }}>
                <BannerTurqouiseBackground {...data} />
              </GridCol>
            )}
          </>
        )
      })}
    </Grid>
  )
})
